import { render, staticRenderFns } from "./LetterHeaderComponent.vue?vue&type=template&id=a09ee35e&"
import script from "./LetterHeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./LetterHeaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a09ee35e')) {
      api.createRecord('a09ee35e', component.options)
    } else {
      api.reload('a09ee35e', component.options)
    }
    module.hot.accept("./LetterHeaderComponent.vue?vue&type=template&id=a09ee35e&", function () {
      api.rerender('a09ee35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Letter/LetterHeaderComponent.vue"
export default component.exports